import { SequenceAttribute } from './SequenceAttribute';
import { JogRangeControl } from '../components/JogRangeControl';
import type { CinematicEditing } from './use-cinematic-waypoints';

export function StudioMapZoom({ editing }: { editing: CinematicEditing }) {
  const value = editing.settings.cameraZoom;
  return <SequenceAttribute editing={editing} name="cameraZoom" label="map zoom">
    <label className="studio-select-row">Map zoom<select aria-label="Map zoom mode" value={value == null ? 'auto' : 'manual'} disabled={editing.readOnly}
      onChange={event => editing.set('cameraZoom', event.target.value === 'auto' ? null : 12)}><option value="auto">Auto</option><option value="manual">Manual</option></select></label>
    {value != null && <JogRangeControl label="Zoom" value={value} min={2} max={20} step={.1} disabled={editing.readOnly} onChange={zoom => editing.set('cameraZoom', zoom)} />}
  </SequenceAttribute>;
}
